/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, ENAX){
	const a = 'is-active';
	const $path = location.pathname;
	let $head = '/news/';
	if($path.indexOf('/en/') !== -1) {
		$head = '/en/news/';
	}

	// 年号プルダウン
	const newsYearList = () => {
		if($('.js-news-yearList').length) {
			let latest = $('.js-news-latest-year').text();
			let earliest = $('.js-news-earliest-year').text();
			let thisCat = $path.split('/')[$path.split('/').length -2];

			const optionVal = (_num) => {
				if($path.match(/\d{4}/)){
					// 文字列に正規表現4桁数値が含まれていたら
					return $path.replace($path.match(/\d{4}/)[0], _num);
				} else {
					// 文字列に正規表現4桁数値が含まれて無かったら
					if(thisCat === 'news') {
						return $head + _num + '/';
					} else {
						return $head + _num + '/'+ thisCat +'/';
					}
				}
			};

			// optionを追加
			let optionText = '最新';
			if($path.split('/')[1] === 'en') {
				optionText = 'Latest';
			}
			let newsVal;
			if($path.match(/\d{4}/)){
				// 文字列に正規表現4桁数値が含まれていたら
				newsVal = $path.replace($path.match(/\d{4}/)[0]+'/', '');
			} else {
				// 文字列に正規表現4桁数値が含まれて無かったら
				newsVal = $path;
			}
			$('.js-news-yearList').append($('<option>').html(optionText).val(newsVal));
			for(let i =latest; i>=earliest; i--) {
				$('.js-news-yearList').append($('<option>').html(''+i+'').val(optionVal(i)));
			}
			// 見ている年をselected
			$('.js-news-yearList').val($path);
			// 選択した年に飛ばす
			$('.js-news-yearList').change(function(){
				location.href = $(this).val();
			});
		}
	};

	// カテゴリカレント
	const newsCategory = () => {
		if($('.js-category').length) {
			let selectedYear = '';
			if($path.match(/\d{4}/)) {
				selectedYear = $path.match(/\d{4}/)[0];
			}

			$('.js-category').each((idx, ele) => {
				let thisHref = $(ele).attr('href');
				let thisCat = thisHref.split('/')[thisHref.split('/').length -2];

				// カレント
				if($path.indexOf(thisCat) !== -1) {
					$('.js-category').removeClass(a);
					$(ele).addClass(a);
				}
				// パスに年号追加
				if(selectedYear !== '') {
					if(thisHref === $head) {
						$(ele).attr('href', $head + selectedYear +'/');
					} else {
						$(ele).attr('href', $head + selectedYear +'/'+ thisCat +'/');
					}
				}
			});
		}
	}


	// ==============================================================
	newsYearList();
	newsCategory();

})(window.jQuery, window.ENAX);
